import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M8 17.355 13.563 12 8 6.645 9.713 5 17 12l-7.287 7L8 17.355Z", fill: "currentColor" }) }));
export default SvgChevronRight;
